<template>
  <div ref="map" class="mapWrap notranslate" :data-step="step" :style="{height: height ? `${height}px` : '100vh'}">
    <div class="mapFrame">
      <div id="naverMap"></div>
    </div>
    <!-- notification toast -->
    <div v-if="noti">
      <div v-if="step === 'ready'" class="noti">{{locale.mobility_toast_ready}}</div>
      <div v-if="step === 'product'" class="noti">{{locale.mobility_toast_product}}</div>
      <div v-if="step === 'pickup'" class="noti">{{locale.mobility_toast_pickup}}</div>
    </div>
    <!-- //notification toast -->
    <!-- mobility steps -->
    <div v-if="!disabled" class="mobilitySearch" :class="{direct: callType === 'direct', destination: callType === 'destination'}">
      <div v-if="callType === 'destination'">
        <div class="steps">
          <span
            v-for="(item, index) in steps"
            :key="item"
            :class="{active: item === step}">
            <i>{{index + 1}}</i>
            <span v-if="item === step" class="label">{{ getStepName(item) }}</span>
          </span>
        </div>
        <!-- ready:: 목적지 설정 -->
        <div v-if="step === 'ready'" class="searchFrame ready">
          <!-- 출발지 -->
          <div class="inputWrap startingPoint mb15">
            <div class="labelBox">
              <span class="label startingLabel toCapitalize">{{locale.mobility_startingpoint}}</span>
              {{ startName }}
            </div>
          </div>
          <!-- //출발지 -->
          <!-- 경유지 -->
          <div v-if="!activePoint" class="mb15">
            <div v-if="waypoints && waypoints.length > 0" class="inputWrap">
              <div class="waypoints">
                <div
                  v-for="(way, index) in  waypoints"
                  :key="index"
                  class="labelBox"
                  @click.stop="setActivePoint('waypoint', index)">
                  <span class="label waypointLabel toCapitalize">{{`${locale.mobility_waypoint}${index + 1} `}}</span>
                  {{ way.name && way.name !== way.address ? `${way.name} (${way.address})` : way.address }}
                  <button type="button" class="btnDel" @click.stop="confirmDelWaypoints(index)"></button>
                </div>
              </div>
            </div>
          </div>
          <!-- //경유지 -->
          <!-- 포인트 설정 -->
          <div v-if="(waypoints && waypoints.length < 2) || !destination">
            <div v-if="!activePoint" class="btnSetPoint">
              <button v-if="!destination" type="button" class="btn" :class="{notSelected: callType === 'direct'}" @click.stop="setActivePoint('destination')">{{locale.mobility_set_destination}}</button>
              <button v-else-if="waypoints && waypoints.length < 2" type="button" class="btnWaypoint" @click.stop="setActivePoint('waypoint')">+ {{locale.mobility_waypoint}}</button>
            </div>
            <div v-else>
              <div class="mb10 withBtn">
                <input
                  :placeholder="pointPlaceholder()"
                  :value="activePoint.name && activePoint.address !== activePoint.name ? `${activePoint.name} (${activePoint.address})` : activePoint.address"
                  type="text"
                  class="input"
                  readonly>
                <button class="btn btnWhite btnCancel" @click="resetActivePoint">{{ locale.cancel }}</button>
              </div>
              <div>
                <button type="button" class="btn btnFull" :disabled="!activePoint.address" @click="confirmActivePoint">
                  {{ pointComplete() }}
                </button>
              </div>
            </div>
          </div>
          <!-- //포인트 설정 -->
          <!-- 목적지 -->
          <div v-if="!activePoint && destination" class="inputWrap destnationPoint btnWrap mt15">
            <div class="inputWrap mb10">
              <div class="labelBox" @click.stop="setActivePoint('destination')">
                <span class="label destinationLabel toCapitalize">{{locale.mobility_destination}}</span>
                {{ destinationName && destinationAddress !== destinationName ? `${destinationName} (${destinationAddress})` : destinationAddress }}
              </div>
            </div>
            <button type="button" class="btn btnFull toCapitalize" :disabled="!(destinationName && destinationAddress)" @click.stop="setCallInformation(true)">{{locale.mobility_set_route_complete}}</button>
          </div>
          <!-- // 목적지 -->
        </div>
        <!-- //ready:: 목적지 설정 -->
        <!-- product:: 상품 선택 -->
        <div v-else-if="step === 'product'" class="searchFrame mobilityProduct">
          <div class="mb15">
            <button type="button" class="btn btnWhite sizeXs toCapitalize" @click.stop="setStepBack('product')">← {{locale.mobility_reset_destination}}</button>
          </div>
          <ul v-if="serviceInfos">
            <li
              v-for="(item, index) in serviceInfos"
              :key="index"
              :class="{active: item.serviceName === activeProduct}"
              class="productItem"
              @click.stop="activeProduct = item.serviceName">
              <div class="thumb"><img :src="item.serviceImage" alt=""></div>
              <div class="info">
                <div class="name">{{ getProductName(item.serviceName) }}</div>
                <div v-if="item.cost" class="cost">
                  <div>{{locale.mobility_cost_call}}: {{ item.cost.callFee === 0 ? '0' : priceFormat(item.cost.callFee, item.cost.currency) }}</div>
                  <div v-if="item.cost.min || item.cost.max">
                    {{locale.mobility_cost_estimated}}:
                    <!-- <span v-if="item.cost.min">{{ priceFormat(item.cost.min, item.cost.currency) }}</span>
                    <span v-if="item.cost.min && item.cost.max"> ~ </span>
                    <span v-if="item.cost.max">{{ priceFormat(item.cost.max, item.cost.currency) }}</span> -->
                    <span v-if="item.cost.max">{{ priceFormat(item.cost.max, item.cost.currency) }}</span>
                  </div>
                </div>
              </div>
              <div class="viewDetail" @click.stop="viewProductDetail(item.serviceName)">{{locale.details}}</div>
            </li>
          </ul>
          <div v-else>{{locale.mobility_product_nodata}}</div>
          <div class="inputWrap btnWrap">
            <button type="button" class="btn btnFull toCapitalize" :disabled="!accessToken" @click.stop="setCallProduct">{{locale.mobility_select_product}}</button>
          </div>
        </div>
        <!-- //product:: 상품 선택 -->
        <!-- pickup:: 픽업위치 확인 -->
        <div v-else class="searchFrame mobilityProduct mobilityPickup">
          <div v-if="step === 'pickup'" class="mb15">
            <button type="button" class="btn btnWhite sizeXs" @click.stop="setStepBack('product')">← {{locale.mobility_reset_destination}}</button>
          </div>
          <div class="inputWrap wayBox">
            <span class="label">{{locale.mobility_pickup_point}}</span>
            {{ pickupName }} ({{ pickupAddress }})
          </div>
          <div v-if="waypoints && waypoints.length" class="inputWrap wayBox">
            <span class="label">{{locale.mobility_waypoint}}</span>
            <div
              v-for="(item, index) in waypoints"
              :key="index"
              class="mt5">
              {{ item.address }}
            </div>
          </div>
          <div class="inputWrap wayBox">
            <span class="label">{{locale.mobility_destination}}</span>
            {{ destinationAddress }}
          </div>
          <div v-if="step === 'pickup'" class="inputWrap btnWrap mt15">
            <button type="button" class="btn btnFull toCapitalize" :disabled="!pickupToken" @click.stop="setRequestRide">{{locale.mobility_set_call}}</button>
          </div>
        </div>
        <!-- //pickup:: 픽업위치 확인 -->
      </div>
      <!-- 목적지 없이 호출 -->
      <div class="setCallType">
        <button type="button" v-if="callType !== 'destination'" class="btn btnDestinationCall" @click.stop="setDestinationCall">{{locale.mobility_set_destination}}</button>
        <button type="button" class="btn btnDirectCall" @click.stop="setDirectCall">{{locale.mobility_no_destination}}</button>
      </div>
      <!-- //목적지 없이 호출 -->
    </div>
    <!-- //mobility steps -->
    <!-- 호출중 -->
    <div v-else class="mobilitySearch">
      <div class="setCallType">
        <router-link :to="{name: 'main', params: {ln: ln}}" class="btn btnGoMain">{{locale.go_main}}</router-link>
        <button type="button" class="btn btnRefresh" @click.stop="reload">{{locale.refresh}}</button>
      </div>
    </div>
    <!-- //호출중 -->
    <!-- 목적지 선택 레이어 -->
    <div v-if="destinationWay" class="layer destinationWay">
      <div class="inner">
        <button type="button" class="btnClose" @click.stop="closeDestinationWay"><span class="blind">close</span></button>
        <div class="btns">
          <button type="button" class="btn btnWhite btnInput toCapitalize" @click.stop="setSearch(true)">{{locale.mobility_search_input}}</button>
          <button type="button" class="btn btnWhite btnMap toCapitalize" @click.stop="setMapSearch(true)">{{locale.mobility_search_map}}</button>
          <button v-if="preset && preset.length > 0" type="button" class="btn btnWhite btnPreset toCapitalize" @click.stop="presetLayer = true">{{ locale.mobility_destination_preset }}</button>
        </div>
      </div>
    </div>
    <!-- //목적지 선택 레이어 -->
    <Search
      v-if="search"
      :locale="locale"
      @selectLocation="selectLocation"
      @close="setSearch(false)" />
    <InfoLayer
      v-if="infoLayer"
      :locale="locale"
      :isDirect="callType === 'direct'"
      :phoneNumber="phone"
      :destinationAddress="destinationAddress"
      :waypoint="waypointAddress"
      @cancel="cancelInfoLayer"
      @confirm="confirmUserInfo" />
    <ProductDetailLayer
      v-if="productDetail"
      :locale="locale"
      :detail="productDetail"
      @close="productDetail = null" />
    <ResultLayer
      v-if="resultLayer"
      :locale="locale"
      :lang="lang"
      :isPublic="isPublic"
      :resultData="resultData"
      @cancel="closeResultLayer" />
    <div v-if="toastList">
      <Toast v-for="toast in toastList"
        :locale="locale"
        :key="toast.id"
        :toast="toast"
        @confirm="toastConfirm" />
    </div>
    <DestinationPreset
      v-if="presetLayer"
      :locale="locale"
      :ln="ln"
      :preset="preset"
      @apply="applyPreset"
      @close="closePreset" />
  </div>
</template>

<script>
import moment from 'moment-timezone'
import regExp from '@/common/regExp'
import UNIQUE from '@/common/unique'
import Toast from '@/components/Util/Toast'
import Search from '@/components/Maps/NaverSearch'
import InfoLayer from '@/components/Maps/InfoLayer'
import ResultLayer from '@/components/Maps/ResultLayer'
import ProductDetailLayer from '@/components/Maps/ProductDetailLayer'
import DestinationPreset from '@/components/Maps/DestinationPreset'

export default {
  name: 'NaverMap',
  props: [
    'locale',
    'lang',
    'ln',
    'isPublic',
    'responsive',
    'origin',
    'disabled',
    'preset'
  ],
  components: {
    Toast,
    Search,
    InfoLayer,
    ResultLayer,
    ProductDetailLayer,
    DestinationPreset
  },
  computed: {
    siteInfo () {
      return this.$store.getters['getSiteInfo']
    },
    // startName () {
    //   return this.$store.getters['common/getTitle']
    // },
    mobilityProduct () {
      const product = this.serviceInfos && this.serviceInfos.find(x => x.serviceName === this.activeProduct)
      return product
    },
    waypointAddress () {
      const waypoints = this.waypoints && this.waypoints.length > 0
      return waypoints
        ? this.waypoints.map(x => x.address)
        : null
    },
    waypointsData () {
      const waypoints = this.waypoints && this.waypoints.length > 0
      return waypoints
        ? this.waypoints.map(x => {
          return {
            lat: x.lat,
            lng: x.lng,
            address: x.address,
            name: x.name
          }
        })
        : null
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.init()
    })
  },
  data () {
    return {
      steps: [
        'ready',
        'product',
        'pickup',
        'request',
        // 'result'
      ],
      step: 'ready', // ready -> product -> pickup -> request -> result
      result: null,
      callType: null,
      clientId: '4i5d0evhqr',
      accessToken: null,
      infoLayer: false,
      resultLayer: false,
      phone: '',
      map: null,
      marker: null,
      status: 'ready',
      height: 800,
      start: null,
      startMarker: null,
      startName: '',
      startAddress: '',
      destination: null,
      destinationMarker: null,
      destinationAddress: '',
      destinationName: '',
      destinationWay: false,
      waypoints: [],
      activeWaypoints: null,
      pickup: null,
      pickupMarker: null,
      pickupAddress: '',
      pickupName: '',
      pickupToken: null,
      polyline: null,
      path: null,
      search: false,
      searchMap: false,
      serviceInfos: null,
      activeProduct: null,
      productDetail: null,
      rideId: null,
      webUrl: null,
      userId: null,
      toastList: [],
      noti: false,
      activePoint: null,
      direction: '',
      resultData: null,
      presetLayer: false,
      isPreset: false
    }
  },
  methods: {
    async init () {
      this.startName = this.origin.startName
      this.setLatLng('start', this.origin.lat, this.origin.lng)
      await this.checkDeviceSize()
      this.status = 'start'
      if (window.naver && window.naver.maps) {
        this.loadMap()
      } else {
        this.loadScript()
      }
      this.initData()
    },
    initData () {
      if (this.activePoint) this.activePoint.marker.setMap(null)
      if (this.destinationMarker) this.destinationMarker.setMap(null)
      if (this.pickupMarker) this.pickupMarker.setMap(null)
      if (this.polyline) this.polyline.setMap(null)
      // if (this.map) this.map.setCenter(this.origin.lat, this.origin.lng)
      this.accessToken = null
      this.status = 'ready'
      this.step = 'ready'
      this.activePoint = null
      this.activeProduct = null
      this.activeWaypoints = null
      this.destination = null
      this.destinationMarker = null
      this.destinationAddress = ''
      this.destinationName = ''
      this.waypoints = []
      this.activeWaypoints = null
      this.pickup = null
      this.pickupMarker = null
      this.pickupAddress = ''
      this.pickupName = ''
      this.pickupToken = null
      this.path = null
      this.serviceInfos = null
      this.productDetail = null
      this.rideId = null
      this.webUrl = null
      this.noti = false
      this.isPreset = null
      if (this.map) {
        this.map.setCenter(new window.naver.maps.Point(this.start.lng, this.start.lat))
        this.map.setZoom(16)
      }
    },
    startDrag (e) {
      console.log(e)
    },
    endDrag (e) {
      console.log(e)
    },
    checkDeviceSize (e) {
      const map = this.$refs.map
      const container = document.getElementById('container')
      const header = document.getElementById('header')
      const containerHeight = container
        ? window.innerHeight - header.offsetHeight
        : 800
      function stringToNumber (str) {
        return parseInt(str || 0)
      }
      // 지도 영역 구간별 width, height
      this.height = map && containerHeight ? containerHeight : 800
      return this.height
    },
    pointPlaceholder () {
      const point = this.activePoint.target === 'waypoint' ? this.locale.mobility_waypoint : this.locale.mobility_destination
      const message = this.locale.mobility_set_point.replace('{point}', point)
      return message
    },
    pointComplete () {
      const point = this.activePoint.target === 'waypoint' ? this.locale.mobility_waypoint : this.locale.mobility_destination
      const message = this.locale.mobility_set_point_complete.replace('{point}', point)
      this.callType = 'destination'
      return message
    },
    getStepName (step) {
      const label = `mobility_step_${step}`
      return this.locale[label]
    },
    setStepBack (step) {
      const backIdx = this.steps.findIndex((x, i) => x === step) - 1 >= 0 ? this.steps.findIndex((x, i) => x === step) - 1 : 0
      const stepBack = this.steps[backIdx]
      this.step = stepBack
      if (stepBack === 'ready') {
        this.searchMap = true
        this.init()
      }
    },
    addToast (trigger, type, message, otherData) {
      const id = UNIQUE.mid()
      const toast = {
        id: id,
        type: type,
        trigger: trigger,
        message: message,
        ...otherData
      }
      this.toastList.push(toast)
    },
    delToast (id) {
      this.toastList = id ? this.toastList.filter(x => x.id !== id) : []
    },
    toastConfirm (data) {
      const trigger = this.toastList.find(x => x.id === data.id) ? this.toastList.find(x => x.id === data.id).trigger : null
      if (!data.isConfirm) {
        this.delToast(data.id)
      } else {
        if (trigger) {
          if (trigger === 'closeToast') {
            this.delToast()
          } else if (trigger === 'cancelSetLayer') {
            this.setCallInformation(false)
            this.delToast()
          } else if (trigger === 'cancelWaypoints') {
            this.activeWaypoints = null
            this.delToast()
          } else if (trigger === 'delWaypoints') {
            this.delWaypoints(data.otherData.index)
            this.delToast()
          }
        } else {
          alert(this.locale.alert_system_error)
          this.delToast()
        }
      }
    },
    getProductName (name) {
      const productName = this.$store.getters['util/getMobilityProductName'](name)
      return this.locale[`mobility_${productName}`]
    },
    priceFormat (price, currency) {
      return price ? regExp.priceFormat(price, currency) : ''
    },
    loadScript () {
      const clientId = this.clientId
      const URL = `https://oapi.map.naver.com/openapi/v3/maps.js?ncpClientId=${clientId}&submodules=geocoder`
      const script = document.createElement('script')
      if (script) {
        script.setAttribute('src', URL)
        script.id = 'naver-map-load'
        script.setAttribute('async', '')
        script.setAttribute('defer', '')
        script.onload = () => this.loadMap()
        document.head.appendChild(script)
      } else {
        throw new Error('api can\'t loaded')
      }
    },
    async loadMap () {
      const lat = this.start.lat
      const lng = this.start.lng
      const container = document.getElementById('naverMap')
      const options = {
        center: new window.naver.maps.LatLng(lat, lng), // 지도의 초기 중심 좌표
        mapTypeControl: false, // 지도 컨트롤 숨김
        disableKineticPan: true, // 지도 이동시 관성 드래깅 켜키
        zoom: 16, // 지도의 초기 줌 레벨
        zoomControl: false // 줌 컨트롤의 표시 여부
      }
      const map = new window.naver.maps.Map(container, options)
      this.map = map
      this.loadMarker()

      window.naver.maps.Event.addListener(map, 'init', (e) => {
        const startPosition = new window.naver.maps.LatLng(lat, lng)
        setTimeout(() => {
          this.setAddressData('startAddress', startPosition, 'short')
        }, 1000)
      })
      window.naver.maps.Event.addListener(map, 'touchend', (e) => {
        if (this.searchMap && this.activePoint) {
          const center = { y: this.activePoint.lat, x: this.activePoint.lng }
          const position = new window.naver.maps.LatLng(center.y, center.x)
          this.setAddressData('activePoint', position)
        }
      })
      window.naver.maps.Event.addListener(map, 'mouseup', (e) => {
        if (this.searchMap && this.activePoint) {
          const center = { y: this.activePoint.lat, x: this.activePoint.lng }
          const position = new window.naver.maps.LatLng(center.y, center.x)
          this.setAddressData('activePoint', position)
        }
      })
      window.naver.maps.Event.addListener(map, 'bounds_changed', (bounds) => {
        if (this.searchMap && this.activePoint) {
          const center = map.getCenter()
          const position = new window.naver.maps.LatLng(center.y, center.x)
          this.activePoint.marker.setPosition(position)
          this.isPreset = null
          this.setLatLng('activePoint', position.y, position.x)
        }
      })
    },
    // 주소 정보 data
    async setAddressData (target, coord, depth) {
      const searchCoordinateToAddress = this.searchCoordinateToAddress
      const address = await coordToAddress(coord, depth)
      async function coordToAddress (coord, depth) {
        return searchCoordinateToAddress(coord, depth)
      }
      if (target === 'activePoint') {
        this.activePoint.address = address
        this.activePoint.name = address
      } else {
        this[target] = address
      }
    },
    setLatLng (target, lat, lng) {
      this[target] = {
        ...this[target],
        lat: parseFloat(lat),
        lng: parseFloat(lng)
      }
      if (target === 'activePoint' && this.activePoint) {
        if (this.activePoint.marker) this.activePoint.marker.setMap(null)
        this.loaddestinationMarker(lat, lng)
      }
    },
    // 출발지 마커
    loadMarker () {
      const map = this.map
      const lat = this.start.lat
      const lng = this.start.lng
      const iconSrc = require('@/assets/img/ico_start_pin.png')
      const options = {
        position: new window.naver.maps.LatLng(lat, lng),
        map: map,
        icon: {
          url: iconSrc,
          size: new window.naver.maps.Size(32, 32),
          scaledSize: new window.naver.maps.Size(32, 32),
          origin: new window.naver.maps.Size(0, 0),
          ancor: new window.naver.maps.Size(16, 32)
        }
      }
      this.startMarker = new window.naver.maps.Marker(options)
    },
    // 목적지 마커
    loaddestinationMarker (lat, lng) {
      const map = this.map
      const label = this.activePoint && this.activePoint.target === 'waypoint'
        ? {
          name: `${this.locale.mobility_waypoint}${this.waypoints.length + 1}`,
          class: 'waypoint'
        } : {
          name: this.locale.mobility_destination,
          class: ''
        }
      const options = {
        position: new window.naver.maps.LatLng(lat, lng),
        map: map,
        icon: {
          content: [
            '<div class="mapMarkerStkr ' + label.class + '"><span class="markerLabel">' + label.name + '</span></div>'
          ].join(''),
          size: new window.naver.maps.Size(84, 52),
          ancor: new window.naver.maps.Size(42, 52)
        }
      }
      this.activePoint.marker = new window.naver.maps.Marker(options)
    },
    // 픽업 마커
    loadPickupMarker (lat, lng) {
      const map = this.map
      const label = this.locale.mobility_pickup_point
      const options = {
        position: new window.naver.maps.LatLng(lat, lng),
        map: map,
        icon: {
          content: [
            '<div class="mapMarkerStkr pickup"><span class="markerLabel">' + label + '</span></div>'
          ].join(''),
          size: new window.naver.maps.Size(76, 52),
          ancor: new window.naver.maps.Size(34, 52)
        }
      }
      this.pickupMarker = new window.naver.maps.Marker(options)
      this.map.setZoom(17, true)
      this.map.panTo(new window.naver.maps.LatLng(lat, lng))
    },
    // 목적지 지도에서 설정하기
    setMapSearch (isActive) {
      this.searchMap = isActive
      this.destinationWay = false
      if (isActive) {
        this.setLatLng('activePoint', this.activePoint.lat, this.activePoint.lng)
        this.map.setZoom(17, true)
        this.map.panTo(new window.naver.maps.LatLng(this.activePoint.lat, this.activePoint.lng))
        this.noti = true
      }
    },
    // 목적지 찾기
    setSearch (isOpen) {
      this.search = isOpen
      this.destinationWay = false
      this.searchMap = false
      if (!isOpen) {
        if (this.activePoint && this.activePoint.marker) this.activePoint.marker.setMap(null)
        this.activePoint = null
      }
    },
    resetActivePoint () {
      const map = this.map
      const target = this.activePoint.target === 'waypoint'
        ? typeof (this.activePoint.index) !== 'undefined'
          ? this.waypoints[this.activePoint.index]
          : null
        : this.destination
      if (target) {
        const lat = target.lat
        const lng = target.lng
        const label = this.activePoint && this.activePoint.target === 'waypoint'
          ? {
            name: `${this.locale.mobility_waypoint}${this.waypoints.length + 1}`,
            class: 'waypoint'
          } : {
            name: this.locale.mobility_destination,
            class: ''
          }
        const options = {
          position: new window.naver.maps.LatLng(lat, lng),
          map: map,
          icon: {
            content: [
              '<div class="mapMarkerStkr ' + label.class + '"><span class="markerLabel">' + label.name + '</span></div>'
            ].join(''),
            size: new window.naver.maps.Size(76, 52),
            ancor: new window.naver.maps.Size(34, 52)
          }
        }
        target.marker = new window.naver.maps.Marker(options)
        map.panTo(new window.naver.maps.LatLng(lat, lng))
      }
      this.activePoint.marker.setMap(null)
      this.activePoint = null
      this.callType = 'destination'
    },
    /**
     * 검색된 목적지 선택 및 설정
     * 목적지 검색시 DaumPost를 사용했으나
     * 주소검색이 아닌 장소검색으로 변경하기 위해
     * Google Place api로 변경
     * (주소를 직접 다루지 않으므로 Address to Coord도 더이상 사용하지 않음)
     */
    selectLocation (data) {
      this.activePoint.name = data.name
      this.activePoint.address = data.address
      this.search = false
      this.destinationWay = false
      this.noti = false
      this.isPreset = null
      this.setLatLng('activePoint', data.location.lat, data.location.lng)
      this.map.setCenter(new window.naver.maps.Point(data.location.lng, data.location.lat))
      this.map.setZoom(17, true)
      this.map.panTo(new window.naver.maps.LatLng(data.location.lat, data.location.lng))
    },
    // 목적지 주소 입력
    setDestinationAddress (address) {
      this.activePoint.address = address
    },
    // 목적지 이름 입력
    setDestinationName (name) {
      this.activePoint.name = name
    },
    closeDestinationWay () {
      this.destinationWay = false
      this.activePoint = null
    },
    setDestinationCall () {
      this.callType = 'destination'
      this.initData()
      this.setActivePoint('destination')
    },
    setDirectCall () {
      this.callType = 'direct'
      this.initData()
      this.setCallInformation(true)
    },
    setActivePoint (target, index) {
      const hasData = target === 'waypoint' && typeof (index) !== 'undefined'
        ? {
          ...this.waypoints[index],
          index: index
        }
        : target === 'destination' && this.destinationAddress
          ? {
            lat: this.destination.lat,
            lng: this.destination.lng,
            address: this.destinationAddress,
            name: this.destinationName,
            marker: this.destinationMarker
          }
          : null
      const currentWaypoint = this.waypoints && this.waypoints.length > 0 ? this.waypoints[this.waypoints.length - 1] : null
      const lat = currentWaypoint
        ? currentWaypoint.lat
        : this.destination && this.destination.lat
          ? this.destination.lat
          : ''
      const lng = currentWaypoint
        ? currentWaypoint.lng
        : this.destination && this.destination.lng
          ? this.destination.lng
          : ''
      if (target === 'destination') {
        this.destinationMarker = null
      }
      this.activePoint = {
        target: target,
        lat: lat,
        lng: lng,
        address: '',
        name: '',
        marker: null,
        ...hasData
      }
      this.destinationWay = true
      this.noti = false
      this.callType = 'destination'
    },
    setBounds () { // 지도 줌 재배치
      let bounds = [
        new window.naver.maps.LatLng(this.start.lat, this.start.lng)
      ]
      if (this.waypoints && this.waypoints[0]) {
        bounds.push(new window.naver.maps.LatLng(this.waypoints[0].lat, this.waypoints[0].lng))
      }
      if (this.waypoints && this.waypoints[1]) {
        bounds.push(new window.naver.maps.LatLng(this.waypoints[1].lat, this.waypoints[1].lng))
      }
      if (this.destination) {
        bounds.push(new window.naver.maps.LatLng(this.destination.lat, this.destination.lng))
      }
      this.map.fitBounds(
        // 지도의 범위 지정을 위한 최소, 최대 위/경도
        new window.naver.maps.LatLngBounds(
          new window.naver.maps.LatLng(
            Math.min.apply(Math, bounds.map(i => { return i.y })),
            Math.min.apply(Math, bounds.map(i => { return i.x }))
          ),
          new window.naver.maps.LatLng(
            Math.max.apply(Math, bounds.map(i => { return i.y })),
            Math.max.apply(Math, bounds.map(i => { return i.x }))
          )
        )
      )
      this.map.setZoom(this.map.getZoom() - 1)
    },
    confirmActivePoint () {
      const isWaypoint = this.activePoint && this.activePoint.target === 'waypoint'
      const waypointIndex = isWaypoint && typeof (this.activePoint.index) !== 'undefined' ? this.activePoint.index : null
      if (isWaypoint) {
        if (typeof (this.activePoint.index) !== 'undefined' && this.waypoints.length > 0) {
          this.waypoints = this.waypoints.map((x, i) => {
            return i === waypointIndex ? this.activePoint : x
          })
        } else {
          this.waypoints.push(this.activePoint)
        }
      } else {
        this.destination = {
          lat: this.activePoint.lat,
          lng: this.activePoint.lng
        }
        this.destinationAddress = this.activePoint.address
        this.destinationMarker = this.activePoint.marker
        this.destinationName = this.activePoint.name
      }
      this.activePoint = null
      this.setBounds()
    },
    // 경유지 설정
    setWaypoints () {
      const lat = this.destination && this.destination.lat ? this.destination.lat : this.start.lat
      const lng = this.destination && this.destination.lng ? this.destination.lng : this.start.lng
      this.destinationWay = true
      this.activeWaypoints = {
        lat: lat,
        lng: lng,
        address: '',
        name: '',
        marker: null
      }
    },
    // 경유지 추가
    addWaypoints () {
      if (this.activeWaypoints) {
        this.waypoints.push(this.activeWaypoints)
        this.activeWaypoints = null
      }
    },
    confirmDelWaypoints (index) {
      this.addToast('delWaypoints', 'confirm', this.locale.confirm_delete, { otherData: { index: index } })
    },
    delWaypoints (index) {
      this.waypoints[index].marker.setMap(null)
      this.waypoints = this.waypoints.filter((x, i) => i !== index)
      if (this.waypoints.length) {
        this.waypoints.forEach(function (way, index) {
          const markerOption = way.marker.getOptions()
          const options = {
            ...markerOption,
            icon: {
              ...way.marker,
              content: [
                `<div class="mapMarkerStkr waypoint"><span class="markerLabel">${this.locale.mobility_waypoint}${index + 1}</span></div>`
              ].join('')
            }
          }
          way.marker.setOptions(options)
        })
      }
      this.setBounds()
    },
    // 목적지 설정하기
    setDestinationPoint () {
      this.destinationWay = true
      this.activeWaypoints = null
    },
    cancelWaypoints () {
      this.addToast('cancelWaypoints', 'confirm', this.locale.confirm_cancel)
    },
    // 주소를 좌표로 변경
    searchAddressToCoordinate (address) {
      const setLatLng = this.setLatLng
      const map = this.map
      window.naver.maps.Service.geocode({
        query: address
      }, (status, response) => {
        if (status === window.naver.maps.Service.Status.ERROR) {
          this.activePoint = null
          return alert('map service status error')
        }
        if (response.v2.meta.totalCount === 0) {
          this.activePoint = null
          return alert('Coordinates cannot be found at this address.')
        }
        const item = response.v2.addresses[0]
        const point = new window.naver.maps.Point(item.x, item.y)
        map.setCenter(point)
        setLatLng('activePoint', item.y, item.x)
        map.setZoom(17, true)
        map.panTo(new window.naver.maps.LatLng(item.y, item.x))
      })
    },
    // 좌표를 주소로 변경
    async searchCoordinateToAddress (latlng, depth) {
      const makeAddress = this.makeAddress
      const addressSearch = latlng => {
        return new Promise((resolve, reject) => {
          window.naver.maps.Service.reverseGeocode({
            coords: latlng,
            orders: [
              window.naver.maps.Service.OrderType.ADDR,
              window.naver.maps.Service.OrderType.ROAD_ADDR
            ].join(',')
          }, function (status, response) {
            if (status === window.naver.maps.Service.Status.ERROR) {
              reject(status)
              return alert('map service status error')
            }

            var items = response.v2.results
            var address = ''
            var htmlAddresses = []

            for (var i = 0, ii = items.length, item; i < ii; i++) {
              item = items[i]
              address = makeAddress(item, depth) || ''
              htmlAddresses.push(address)
            }
            resolve(htmlAddresses[htmlAddresses.length - 1])
          })
        })
      }
      const result = await addressSearch(latlng)
      return result
    },
    /**
     * 주소 만들기(한글로 return)
     * depth - 1: 시군구 제외
     * depth - default: 전체주소
     */
    makeAddress (item, depth) {
      if (!item) {
        return
      }

      var name = item.name
      var region = item.region
      var land = item.land
      var isRoadAddress = name === 'roadaddr'

      var sido = ''; var sigugun = ''; var dongmyun = ''; var ri = ''; var rest = ''

      function hasArea (area) {
        return !!(area && area.name && area.name !== '')
      }

      function hasData (data) {
        return !!(data && data !== '')
      }

      function checkLastString (word, lastString) {
        return new RegExp(lastString + '$').test(word)
      }

      function hasAddition (addition) {
        return !!(addition && addition.value)
      }

      if (hasArea(region.area1)) {
        sido = region.area1.name
      }

      if (hasArea(region.area2)) {
        sigugun = region.area2.name
      }

      if (hasArea(region.area3)) {
        dongmyun = region.area3.name
      }

      if (hasArea(region.area4)) {
        ri = region.area4.name
      }

      if (land) {
        if (hasData(land.number1)) {
          if (hasData(land.type) && land.type === '2') {
            rest += '산'
          }

          rest += land.number1

          if (hasData(land.number2)) {
            rest += ('-' + land.number2)
          }
        }

        if (isRoadAddress === true) {
          if (checkLastString(dongmyun, '면')) {
            ri = land.name
          } else {
            dongmyun = land.name
            ri = ''
          }

          if (hasAddition(land.addition0)) {
            rest += ' ' + land.addition0.value
          }
        }
      }
      return depth === 'short'
        ? [dongmyun, ri, rest].join(' ')
        : [sido, sigugun, dongmyun, ri, rest].join(' ')
      // return [dongmyun, ri, rest].join(' ')
    },
    setPolyline (pathArr) {
      const map = this.map
      const path = pathArr.map(x => {
        return new window.naver.maps.LatLng(x.lat, x.lng)
      })
      this.polyline = new window.naver.maps.Polyline({
        map: map,
        path: path,
        strokeWeight: 5
      })
    },
    cancelInfoLayer () {
      this.addToast('cancelSetLayer', 'confirm', this.locale.confirm_cancel)
    },
    setCallInformation (isOpen) {
      this.infoLayer = isOpen
    },
    applyPreset (data) {
      this.selectLocation(data)
      this.isPreset = data.presetId
      this.closePreset()
    },
    setPreset () {
      this.presetLayer = true
    },
    closePreset () {
      this.presetLayer = false
    },
    setPickup (data) {
      this.pickup = {
        lat: data.lat,
        lng: data.lng
      }
      this.pickupAddress = data.address
      this.pickupName = data.name
      this.pickupToken = data.token
      this.loadPickupMarker(data.lat, data.lng)
      this.step = 'pickup'
      this.noti = true
    },
    confirmUserInfo (phone) {
      if (this.callType === 'direct') {
        this.setRequestDestLessRide(phone)
      } else {
        this.setDestination(phone)
      }
    },
    setDestination (phone) {
      const start = this.start
      const destination = this.destination
      const data = {
        lang: this.ln,
        phone: phone,
        origin: {
          lng: start.lng,
          lat: start.lat,
          name: this.startName,
          address: this.startName
        },
        destination: {
          lng: destination.lng,
          lat: destination.lat,
          name: this.destinationAddress,
          address: this.destinationName || this.destinationAddress
        },
        ...this.waypointsData && {
          waypoints: this.waypointsData
        }
      }
      this.phone = phone
      this.searchMap = false
      this.$store.commit('loading', true)
      this.$store.dispatch('guest/setDestination', data).then((res) => {
        this.$store.commit('loading', false)
        if (res) {
          if (res.accessToken) {
            this.accessToken = res.accessToken
            if (res.route && res.route.routeUnits) {
              const polylinePath = res.route.routeUnits.flatMap(x => {
                const points = x.points.map(p => {
                  return {
                    lat: p.lat,
                    lng: p.lng
                  }
                })
                return points
              })
              this.setPolyline(polylinePath)
            }
            if (res.serviceInfos) {
              this.serviceInfos = res.serviceInfos
              this.activeProduct = res.serviceInfos && res.serviceInfos[0] ? res.serviceInfos[0].serviceName : ''
            }
            this.step = 'product'
            this.noti = true
          } else if (res.status && res.message) {
            /**
             * 에러 메시지는 운영사마다 상이하므로 서버에서 반환하는 메시지를 그대로 사용
             * 단, 403은 특정 에러 외 케이스로 locale 메시지 사용
             */
            const errMessage = res.status === 403 ? this.locale.ask_front : res.message
            alert(errMessage)
            this.searchMap = true
          } else {
            alert(this.locale.system_error)
            this.searchMap = true
          }
        } else {
          alert(this.locale.system_error)
          this.searchMap = true
        }
        this.setCallInformation(false)
        this.delToast()
      })
    },
    setCallProduct () {
      const start = this.start
      const destination = this.destination
      const data = {
        lang: this.ln,
        accessToken: this.accessToken,
        serviceType: this.activeProduct,
        origin: {
          lng: start.lng,
          lat: start.lat,
          name: this.startName,
          address: this.startName
        },
        destination: {
          lng: destination.lng,
          lat: destination.lat,
          name: this.destinationAddress,
          address: this.destinationName || this.destinationAddress
        },
        ...this.waypointsData && {
          waypoints: this.waypointsData
        }
      }
      this.product = null
      this.callType = 'destination'
      this.$store.commit('loading', true)
      this.$store.dispatch('guest/getPickup', data).then((res) => {
        this.$store.commit('loading', false)
        if (res) {
          if (res.isAvailable) {
            const pickup = {
              address: res.expectedPickupPoint.address,
              name: res.expectedPickupPoint.name,
              lat: res.expectedPickupPoint.lat,
              lng: res.expectedPickupPoint.lng,
              token: res.pickupToken
            }
            this.setPickup(pickup)
          } else if (res.status && res.message) {
            /**
             * 에러 메시지는 운영사마다 상이하므로 서버에서 반환하는 메시지를 그대로 사용
             * 단, 403은 특정 에러 외 케이스로 locale 메시지 사용
             */
            const errMessage = res.status === 403 ? this.locale.ask_front : res.message
            alert(errMessage)
            this.searchMap = true
          } else {
            alert(this.locale.system_error)
            this.searchMap = true
          }
        } else {
          alert(this.locale.system_error)
          this.searchMap = true
        }
      })
    },
    viewProductDetail (serviceType) {
      const item = this.serviceInfos && this.serviceInfos.find(x => x.serviceName === serviceType)
      const start = this.start
      const data = {
        lang: this.ln,
        accessToken: this.accessToken,
        serviceType: serviceType,
        origin: {
          lng: start.lng,
          lat: start.lat,
          name: this.startName,
          address: this.startName
        }
      }
      this.$store.commit('loading', true)
      this.$store.dispatch('guest/getServiceDesc', data).then((res) => {
        this.$store.commit('loading', false)
        if (res) {
          this.productDetail = {
            ...res,
            ...item
          }
        } else if (res.status && res.status === 403) {
          const resData = res.data && res.data.message
          const status = resData && resData.status
          const errMessage = status && status === 403 ? this.locale.ask_front : resData.message
          alert(errMessage)
          this.productDetail = null
        } else {
          alert(this.locale.system_error)
          this.productDetail = null
        }
      })
    },
    setRequestRide () {
      const pickup = this.pickup
      const destination = this.destination
      const data = {
        lang: this.ln,
        phone: this.phone,
        accessToken: this.accessToken,
        serviceToken: this.mobilityProduct.serviceToken,
        pickupPointToken: this.pickupToken,
        serviceType: this.activeProduct,
        origin: {
          lng: pickup.lng,
          lat: pickup.lat,
          name: this.pickupName,
          address: this.pickupAddress
        },
        destination: {
          lng: destination.lng,
          lat: destination.lat,
          name: this.destinationAddress,
          address: this.destinationName || this.destinationAddress
        },
        ...this.waypointsData && {
          waypoints: this.waypointsData
        }
      }
      this.callType = 'destination'
      this.$store.commit('loading', true)
      this.$store.dispatch('guest/requestRide', data).then((res) => {
        this.$store.commit('loading', false)
        if (res) {
          if (res.rideId) {
            this.rideId = res.rideId
            this.webUrl = res.webUrl
            this.userId = res.userId
            console.log(res.rideId)
            this.setOrderRide(res.rideId)
          } else if (res.status && res.message) {
            const errMessage = res.status === 403 ? this.locale.ask_front : res.message
            alert(errMessage)
            this.resultLayer = false
            if (res.status === 304) { // 토큰 유효시간 만료로 재요청
              this.setDestination(this.phone)
            }
          } else {
            alert(this.locale.system_error)
            this.resultLayer = false
          }
        } else {
          alert(this.locale.system_error)
          this.resultLayer = false
        }
      })
    },
    // 목적지 없이 호출
    setRequestDestLessRide (phone) {
      const start = this.start
      const data = {
        lang: this.ln,
        phone: phone || this.phone,
        origin: {
          lng: start.lng,
          lat: start.lat,
          name: this.startName,
          address: this.startAddress
        }
      }
      if (!this.phone && phone) {
        this.phone = phone
      }
      this.$store.commit('loading', true)
      this.$store.dispatch('guest/requestDestLessRider', data).then((res) => {
        this.$store.commit('loading', false)
        if (res) {
          if (res.rideId) {
            this.rideId = res.rideId
            this.webUrl = res.webUrl
            this.userId = res.userId
            this.accessToken = res.accessToken
            this.setOrderRide(res.rideId)
          } else if (res.status && res.message) {
            const errMessage = res.status === 403 ? this.locale.ask_front : res.message
            alert(errMessage)
            this.resultLayer = false
          } else {
            alert(this.locale.system_error)
            this.resultLayer = false
          }
        } else {
          alert(this.locale.system_error)
          this.resultLayer = false
        }
        this.isPreset = null
        this.setCallInformation(false)
        this.delToast()
      })
    },
    setOrderRide (rideId) {
      const langObj = this.$store.state.common.setting.lang.info
      const subject = function (langObj, val) {
        let obj = {}
        langObj.map(x => {
          obj[x.c] = val || ''
        })
        return obj
      }
      const submitData = {
        title: 'Request mobility',
        info: {
          subject: subject(langObj, 'Request mobility'),
          thumb: ''
        },
        submitAt: moment().toISOString(),
        submitId: 'system_mobility',
        catCode: 'system_mobility',
        categoryLabel: 'Mobility',
        content: [
          {
            id: 'rideId',
            label: 'rideId',
            type: 'input',
            value: rideId
          },
          {
            id: 'phone',
            label: 'phone',
            type: 'input',
            value: this.phone
          },
          {
            id: 'start',
            label: 'starting point',
            type: 'input',
            value: this.pickupAddress
          },
          {
            id: 'destination',
            label: 'destination point',
            type: 'input',
            value: this.destinationAddress
          },
          {
            id: 'webUrl',
            label: 'web url',
            type: 'input',
            value: this.webUrl
          },
          ...this.isPreset ? [
            {
              id: 'isPreset',
              label: 'Preset destination',
              type: 'input',
              value: this.isPreset

            }
          ] : []
        ],
        pId: this.accessToken
      }
      const orderData = {
        isArray: true,
        payload: [submitData],
        price: {
          option: null,
          info: {
            currency: 'KRW',
            noPrice: true,
            price: null,
            quantity: null,
            sum: 0,
            total: 0
          }
        },
        partnerOrder: `tada_${rideId}`
      }
      this.$store.commit('loading', true)
      this.$store.dispatch('submit/setSubmit', orderData).then((res) => {
        console.log(orderData)
        this.$store.commit('loading', false)
        this.step = 'request'
        if (res) {
          this.result = 'success'
          this.resultData = {
            accessToken: this.accessToken,
            webUrl: this.webUrl,
            userId: this.userId
          }
        } else {
          this.result = 'fail'
          alert(this.locale.alert_system_error)
        }
        this.resultLayer = true
      })
    },
    closeResultLayer () {
      this.resultLayer = false
      this.$emit('completeCycle')
    },
    reload () {
      this.$emit('reload')
    }
  }
}
</script>
